export const referralKeys = {
  all: ['referrals'],
  list: (params: any) => ['referrals', 'list', params],
  detail: (id: any) => ['referrals', 'detail', id],
};
